import { useState } from "react";
import DrawerClosetInPreparationRecap from "./DrawerClosetInPreparationRecap";
import DrawerClosetRTPNextStepsExplanation from "../../DrawerClosetRTPNextStepsExplanation";

function DrawerClosetInPreparation() {
  const [step, setStep] = useState("closetInPreparation");

  return (
    <>
      <DrawerClosetInPreparationRecap setStep={setStep} />
      <DrawerClosetRTPNextStepsExplanation
        open={step === "nextStepsExplanation"}
        setStep={setStep}
      />
    </>
  );
}

export default DrawerClosetInPreparation;
